import Vue from "vue";
import Vuex from "vuex";
import VueGlobalVar from "vue-global-var";
import App from "./App.vue";
import Router from "vue-router";
import { routes, routesHelper } from './routes';

import cfg from "./config";
import tools from "./lib/tools";

import "./scss/style.scss";

Vue.config.productionTip = false;

var filter = function(text, length, clamp){
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);
Vue.use(Vuex);
Vue.use(Router);

    // add redirect for non-routes
    routesHelper.finalizeRoutes(routes);

    // add the router
    const routerConfig = {
      routes,
      mode: "history"
    };
    const router = new Router(routerConfig);


new Vue({
  router,
  render: c => {
    return c(App, {
      props: {
        msg: "dev"
      }
    });
  }
}).$mount("#app");

tools.log(`Participatiewijzer ${cfg.VERSION}`);

Vue.use(VueGlobalVar, {
  globals: {
    doelSlugInitiatief: "nieuw",
},
});
